import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FunctionComponent } from 'react';

const HelpingAbout: FunctionComponent = () => {
  return (
    <Box className="py-8">
      <Typography variant="body1">
        It's not always easy to know what to say when someone tells you they've been sexually assaulted, especially when that person is a family member, friend, or loved one. If you're looking for
        information on how to support a child, visit RAINN's website. Consider the following ways of showing support:
      </Typography>

      <Typography variant="body1">
        <ul className="rhs-hotlines-list">
          <li>Listen. Be there. Communicate without judgement.</li>
          <li>If the survivor seeks medical attention or plans to report, offer to be there. Your presence can offer the support they need.</li>
          <li>Encourage the survivor to get support. Share resources like the National Sexual Assault Hotline and online.rainn.org, but realize that only they can make the decision to get help.</li>
          <li>Be patient. Remember, there is no timetable for recovering from trauma. Avoid putting pressure on them to engage in activities they aren't ready to do yet.</li>
          <li>Encourage them to practice good self care during this difficult time.</li>
          <li>
            If someone you care about is considering suicide, learn the warning signs, and offer help and support. For more information about suicide prevention please visit the National Suicide
            Prevention Lifeline or call 800.273.TALK (8255) any time, day or night.
          </li>
        </ul>
        It's important that you take care of yourself, too. You can call the {process.env.NX_ORGANIZATION_NAME} at 800.656.HOPE (4673) or visit online.rainn.org and receive confidential support.
      </Typography>
    </Box>
  );
};
export default HelpingAbout;
